import * as React from "react";
import { connect } from "react-redux";
import { RouteComponentProps } from "react-router";
import Auth from "../../auth/Auth";
import { IStore } from "../../models/IStore";

export interface ICallbackSamlProdAuProps extends RouteComponentProps {
  auth: Auth;
}

export class CallbackSamlProdAu extends React.Component<ICallbackSamlProdAuProps> {
  public constructor(props: ICallbackSamlProdAuProps) {
    super(props);
  }

  public componentDidMount() {
    const { auth } = this.props;

    auth.loginSAMLProdAu().then(() => {
      console.log("Login via SAML Prod Australia");
    });
  }

  public render() {
    return <div>Loading...</div>;
  }
}

const mapStateToProps = (state: IStore) => {
  return {
    auth: state.auth0
  };
};

export default connect(mapStateToProps)(CallbackSamlProdAu);
